module.exports = __webpack_public_path__ + "img/logo_cleaner3.2b26b1df.png";